import { FooterLogos } from "@shared/components/AuthFooter/FooterLogos/FooterLogos";
import { FooterPrivacy } from "@shared/components/AuthFooter/FooterPrivacy/FooterPrivacy";
import { useBreakpoints } from "@shared/hooks/useBreakpoints/useBreakpoints";

import { footer, footerLogos, privacyPolicy } from "./StoreLandingFooter.styles";

const StoreLandingFooter = () => {
  const { phoneLarge } = useBreakpoints();

  return (
    <div css={footer}>
      <div css={phoneLarge.greaterThan && footerLogos}>
        <FooterLogos />
      </div>
      <FooterPrivacy css={privacyPolicy} />
    </div>
  );
};

export { StoreLandingFooter };
